
import ProductOptionTypeHelper from '@/mixins/ProductOptionTypeHelper';

export default {
  i18nComponentKey: 'WidgetProductReviewsProductOptions.components.ProductOptionsSearchBar',
  name: 'ProductOptionsSearchBar',
  mixins: [ProductOptionTypeHelper],
  props: {
    initialProductOptionValues: { type: Object, required: true }
  },
  data() {
    return {
      selectedProductOptionValues: {}
    };
  },
  created() {
    this.selectedProductOptionValues = this.initialProductOptionValues;
    this.fetchProductOptionTypes();
  },
  methods: {
    onChangeProductOption(id) {
      this.$emit('submit', {
        [`product_option_${id}`]: this.selectedProductOptionValues[id]
      });
    }
  }
};
